import { Area } from '../types/checkout';
import { checkoutStore as programCheckoutStore } from 'stores/programCheckoutStore';
import { checkoutStore as rentalCheckoutStore } from 'stores/rentalCheckoutStore';
import {
	checkoutStore as membershipCheckoutStore,
	checkoutStore as passesCheckoutStore,
} from 'stores/membershipCheckoutStore';
// import { checkoutStore as leagueCheckoutStore } from 'stores/leagueCheckoutStore';

const CheckoutStoresEnum = {
	program: programCheckoutStore,
	rental: rentalCheckoutStore,
	membership: membershipCheckoutStore,
	league: programCheckoutStore,
	passes: passesCheckoutStore,
};

export const getCheckoutStore = (area: Area) => CheckoutStoresEnum[area];
